/**
 * Validiert ein Navigationsziel, das aus einem Query-Parameter stammt
 * (z. B. `?weiter=`), bevor es an `navigate()` oder `<Navigate to>`
 * uebergeben wird.
 *
 * Hintergrund: react-router hatte einen Open-Redirect ueber Backslashes
 * (GHSA-wrjc-x8rr-h8h6) -- ein Ziel wie `/\evil.com` oder `//evil.com`
 * wird von Browsern als protokoll-relative URL interpretiert und fuehrt
 * dadurch von der eigenen Domain weg, obwohl es syntaktisch wie ein
 * relativer Pfad aussieht. `ProtectedRoute` setzt `weiter` zwar selbst
 * aus dem eigenen Pfad, aber der Parameter ist Teil der URL und damit
 * frei waehlbar -- ein Angreifer kann direkt auf
 * `/login?weiter=%2F%5Cevil.com` verlinken.
 *
 * Erlaubt wird nur ein Pfad, der mit genau einem `/` beginnt und weder
 * ein zweites `/` noch ein `\` direkt danach hat -- alles andere
 * (absolute URLs, protokoll-relative URLs, Backslash-Tricks) faellt auf
 * den Fallback zurueck.
 */
export function sicheresZiel(wert: string | null | undefined, fallback = '/'): string {
  if (!wert) return fallback;
  if (!/^\/(?!\/|\\)/.test(wert)) return fallback;
  if (wert.includes('\\')) return fallback;
  return wert;
}
